module.exports = __webpack_public_path__ + "img/dqqk.578011d2.png";